import RecentJobCard from "../cards/recentJobCard";
import PageTitle from "./pageTitle";
import { useContext, useState, useEffect } from "react";
import { JobContext, CategoryContext } from "../../App";
import ReactPaginate from "../common/ReactPaginate";
import { Link } from "react-router-dom";
import MailSubscription from "../cards/emailSub";
import ContactForm from "../cards/contactForm";
import { Helmet } from "react-helmet-async";
import RecentJobSkeleton from "./skeletons/recentJob";

function Items({ currentItems }: any) {
  const safeItems = Array.isArray(currentItems) ? currentItems : [];
  return (
    <div className="cht-grid cht-grid-cols-1 sm:cht-grid-cols-2 lg:cht-grid-cols-3 cht-gap-6 sm:cht-gap-8">
      {safeItems.map((item: any) => (
        <Link
          key={item?.id || item?.slug}
          className="!cht-no-underline cht-block cht-h-full"
          to={"/recent-jobs/" + item?.slug}
        >
          <RecentJobCard
            key={item?.id}
            title={item?.title}
            body={item?.safe_summary_html}
            category={item?.category}
            thumbnail={item?.get_image_url}
            date={item?.date}
            location={item?.location}
          />
        </Link>
      ))}
    </div>
  );
}

function PaginatedItems({ itemsPerPage, data, selectedCategory }: any) {
  const safeData = Array.isArray(data) ? data : [];
  const items = safeData;
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    setItemOffset(0);
  }, [selectedCategory]);

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % (items.length || 1);
    setItemOffset(newOffset);
  };

  return (
    <div className="cht-w-full">
      <Items currentItems={currentItems} />

      {items.length > itemsPerPage ? (
        <ReactPaginate
          previousLabel={`Prev`}
          nextLabel={"Next"}
          breakLabel="..."
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          renderOnZeroPageCount={null}
          marginPagesDisplayed={3}
          containerClassName={"cht-flex cht-items-center cht-justify-center cht-gap-1 sm:cht-gap-2 cht-my-10 cht-list-none cht-p-0"}
          pageClassName={""}
          pageLinkClassName={"cht-w-10 cht-h-10 cht-flex cht-items-center cht-justify-center cht-rounded-xl cht-text-sm !cht-font-body cht-font-semibold cht-text-slate-600 hover:cht-bg-slate-100 hover:cht-text-[#3e57da] cht-transition-all cht-duration-200 cht-border cht-border-slate-200/80 !cht-no-underline"}
          previousClassName={""}
          previousLinkClassName={"cht-px-4 cht-h-10 cht-flex cht-items-center cht-justify-center cht-rounded-xl cht-text-sm !cht-font-body cht-font-semibold cht-text-slate-600 hover:cht-bg-slate-100 hover:cht-text-[#3e57da] cht-transition-all cht-duration-200 cht-border cht-border-slate-200/80 !cht-no-underline"}
          nextClassName={""}
          nextLinkClassName={"cht-px-4 cht-h-10 cht-flex cht-items-center cht-justify-center cht-rounded-xl cht-text-sm !cht-font-body cht-font-semibold cht-text-slate-600 hover:cht-bg-slate-100 hover:cht-text-[#3e57da] cht-transition-all cht-duration-200 cht-border cht-border-slate-200/80 !cht-no-underline"}
          breakClassName={""}
          breakLinkClassName={"cht-w-10 cht-h-10 cht-flex cht-items-center cht-justify-center cht-text-sm cht-text-slate-400"}
          activeClassName={"[&>a]:!cht-bg-[#3e57da] [&>a]:!cht-text-white [&>a]:!cht-border-[#3e57da] [&>a]:!cht-shadow-sm"}
          disabledClassName={"[&>a]:!cht-opacity-40 [&>a]:!cht-pointer-events-none"}
        />
      ) : null}
    </div>
  );
}

function RecentJob() {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filteredProducts, setFilteredProducts] = useState<any[]>([]);

  const { jobs, jobLoading } = useContext(JobContext);
  const categories = useContext(CategoryContext);

  const safeJobs = Array.isArray(jobs) ? jobs : [];
  const safeCategories = Array.isArray(categories) ? categories : [];
  const categoryNames = safeCategories.map((cat: any) => cat?.name).filter(Boolean);

  useEffect(() => {
    const filtered = selectedCategory
      ? safeJobs.filter((job: any) => {
          const itemCategories = Array.isArray(job?.category) ? job.category : [];
          return itemCategories.some((category: any) => category?.name === selectedCategory);
        })
      : safeJobs;

    setFilteredProducts(Array.isArray(filtered) ? filtered : []);
  }, [selectedCategory, safeJobs]);

  const handleCategoryChange = (category: string) => {
    setSelectedCategory(category);
  };

  return (
    <>
      <Helmet>
        <title>Deliverables & Portfolio - Codehub Technologies</title>
      </Helmet>

      <PageTitle title="Recent Deliverables" />

      {Array.isArray(filteredProducts) && filteredProducts.length > 0 && (
        <section className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-12 sm:cht-py-16 !cht-font-body">
          {/* Category Filter Pills */}
          <div className="cht-flex cht-flex-wrap cht-items-center cht-justify-center cht-gap-2 sm:cht-gap-2.5 cht-mb-10 sm:cht-mb-12">
            <button
              type="button"
              onClick={() => handleCategoryChange("")}
              className={`cht-px-5 cht-py-2 cht-rounded-full cht-text-xs sm:cht-text-sm cht-font-semibold cht-transition-all cht-duration-200 ${
                selectedCategory === ""
                  ? "cht-bg-[#3e57da] cht-text-white cht-shadow-soft"
                  : "cht-bg-slate-100 hover:cht-bg-slate-200/80 cht-text-slate-600 hover:cht-text-[#1e293b]"
              }`}
            >
              All Projects
            </button>
            {categoryNames.map((item: string) => (
              <button
                key={item}
                type="button"
                onClick={() => handleCategoryChange(item)}
                className={`cht-px-5 cht-py-2 cht-rounded-full cht-text-xs sm:cht-text-sm cht-font-semibold cht-transition-all cht-duration-200 ${
                  selectedCategory === item
                    ? "cht-bg-[#3e57da] cht-text-white cht-shadow-soft"
                    : "cht-bg-slate-100 hover:cht-bg-slate-200/80 cht-text-slate-600 hover:cht-text-[#1e293b]"
                }`}
              >
                {item}
              </button>
            ))}
          </div>

          <PaginatedItems
            itemsPerPage={6}
            data={filteredProducts}
            selectedCategory={selectedCategory}
          />
        </section>
      )}

      {jobLoading && <RecentJobSkeleton numberOfCols={6} />}

      <MailSubscription />
      <ContactForm />
    </>
  );
}

export default RecentJob;
